// Que conceptos puede elegir una parcialidad al vincularse.
//
// SOLO los que este plan incluye. Antes se pasaba el catalogo completo de la
// organizacion y el dueno lo encontro en PROD: al abrir "Vincular a concepto" en el
// plan de FLAG salian FUNDA y JERSEY TACKLE, que son prendas de tackle.
//
// No es cosmetico: vincular un pago a un concepto que el plan no incluye deja el
// cobro apuntando al vacio -- ese concepto no tiene monto aqui, asi que nada podria
// decir si se pago.
export const opcionesDeConceptoDelPlan = (conceptos = [], conceptoOptions = []) => {
  const vistos = new Set()
  return (conceptos || [])
    .filter((c) => {
      if (!c?.concepto_id || vistos.has(c.concepto_id)) return false
      vistos.add(c.concepto_id)
      return true
    })
    .map((c) => ({
      value: c.concepto_id,
      label: (conceptoOptions || []).find((o) => o.value === c.concepto_id)?.label || 'Concepto',
    }))
}
